import { useEffect } from "react";
import { useParams } from "react-router";
import { useData } from "../services/DataProvider";
import ClassInsights from "../components/ClassInsights";

const ObserveClass: React.FC = () => {
  const { classID } = useParams<{classID: string}>();
  const { synching, synchingObservedClass, observedClassData, observeClass, standards } = useData();

  useEffect(() => {
    if (classID) {
      observeClass(classID);
    }
  }, [classID, observeClass]);

  if (synching || synchingObservedClass) { // Second should already be included in first.
    return <div>Loading class data...</div>;
  }

  if (!observedClassData) {
    return <div>Class not found or error loading data.</div>;
  }

  // Create assignment summaries using the data from observedClassData
  const assignmentsToSummaries = Object.fromEntries(observedClassData.assignments.map((assignment) => {
    const completedCount = observedClassData.assignmentsToCompletedCounts[assignment.id || ""] || 0;
    const quizName = observedClassData.quizzes?.filter((quiz) => quiz.id?.trim() === assignment.quizID.trim())?.[0]?.name;

    return [assignment.id, {
      completed: completedCount,
      quizName: quizName,
      inferredKnowledgeByStandard: {},
      standardAverages: observedClassData.assignmentsToStandardAverages[assignment.id || ""] || {}
    }];
  }));

  return (
    <ClassInsights
      classData={observedClassData.class}
      assignments={observedClassData.assignments}
      enrollments={[]}
      enrollmentCount={observedClassData.enrollmentCount}
      assignmentsToSummaries={assignmentsToSummaries}
      standards={standards}
      isReadOnly={true}
    />
  );
};

export default ObserveClass; 